// Converts ISO date string to human-readable format (DD MMM YYYY, HH:MM)
export const formatDate = (isoString) => {
  if (!isoString) return 'N/A';
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return 'N/A'; // <-- provjera da li je validan datum
  return date.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

// Safely extract metrics data for charts
// - ROC and Precision-Recall expect an array
// - Prediction distribution expects a 'bins' array with bin_label and count
export const safeMetricsData = (data, type) => {
  if (!data) return [];

  switch (type) {
    case 'roc':
    case 'precision-recall':
      return Array.isArray(data) ? data : [];
    case 'prediction-distribution':
      return Array.isArray(data?.bins)
        ? data.bins.map((b) => ({
            bucket: b.bin_label ?? 'N/A', // Changed key to 'bucket' to match charts
            count: b.count ?? 0,
          }))
        : [];
    default:
      return [];
  }
};

// Converts a string to a safe key for chart mapping or table rendering
export const toKey = (str) => str.replace(/\s+/g, '_');

// Transform confusion matrix into chart-friendly array of objects
// Each row gets an object { label: actualLabel, predictedLabel1: count, ... }
export const getConfusionChartData = (metricsData) => {
  if (!metricsData || !metricsData.matrix || !metricsData.labels) return [];

  return metricsData.matrix.map((row, i) => {
    const obj = { label: metricsData.labels[i] };
    metricsData.labels.forEach((lbl, j) => {
      const safeKey = toKey(lbl);
      obj[safeKey] = row[j];
    });
    return obj;
  });
};

// Predefined traffic split percentages for A/B testing
export const balanceMap = {
  Conservative: 33,
  Balanced: 50,
  Aggressive: 67,
};
